import React from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import * as modalActions from 'src/store/action-methods/modal'
import * as modalSelectors from 'src/store/selectors/modal'

import Modal from './index'

const ReduxModal = ({ modal, setModal }) => {
  const close = () => {
    setModal({ open: false })
  }

  const { open, color, title, body, choices, large, className, onOpen } = modal

  return (
    <Modal
      id="redux"
      open={open}
      title={title}
      color={color}
      choices={choices}
      className={className}
      large={large}
      onOpen={onOpen}
      onRequestClose={close}>
      {/* TODO: Add Spinner to show if the modal content is in loading state. */}
      {/* {loading && (
        <div className="yd-modal__loading">
          <Spinner />
        </div>
      )} */}

      <div className="p-4 lg:px-8">{body}</div>
    </Modal>
  )
}

const mapStateToProps = createStructuredSelector({
  modal: modalSelectors.modalSelector
})

const mapDispatchToProps = {
  setModal: modalActions.setModal
}

export default connect(mapStateToProps, mapDispatchToProps)(ReduxModal)
